function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4445 9.75405L15.3634 4.7973C15.5905 4.57027 15.5905 4.22973 15.3634 4.0027L14.6067 3.20811C14.3796 2.98108 14.0391 2.98108 13.8121 3.20811L8.85532 8.16486C8.70397 8.31622 8.47694 8.31622 8.32559 8.16486L3.36883 3.17027C3.1418 2.94324 2.80126 2.94324 2.57424 3.17027L1.77964 3.96486C1.55261 4.19189 1.55261 4.53243 1.77964 4.75946L6.7364 9.71622C6.88775 9.86757 6.88775 10.0946 6.7364 10.2459L1.7418 15.2405C1.51478 15.4676 1.51478 15.8081 1.7418 16.0351L2.5364 16.8297C2.76342 17.0568 3.10397 17.0568 3.33099 16.8297L8.28775 11.873C8.4391 11.7216 8.66613 11.7216 8.81748 11.873L13.7742 16.8297C14.0013 17.0568 14.3418 17.0568 14.5688 16.8297L15.3634 16.0351C15.5905 15.8081 15.5905 15.4676 15.3634 15.2405L10.4445 10.2838C10.2932 10.1324 10.2932 9.9054 10.4445 9.75405Z",
  fill: "#EF4444"
});
function SvgStatusFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusFailure);
export default __webpack_public_path__ + "static/media/statusFailure.39f26c550d98de321358eb114c7f53a6.svg";
export { ForwardRef as ReactComponent };